module.exports = __webpack_public_path__ + "static/img/turntable.55ff1c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/turntable.png
// module id = T1AC
// module chunks = 1